import './styles/globalStyles.scss'
import HomePage from './paginas/HomePage'

export default function App() {
    return (
        <>
            <HomePage/>
        </>
    )
}